import gql from 'graphql-tag'

export const CREATE_BANK_ACCOUNT = gql`
  mutation ($input: CreateBankAccountInput!) {
    createBankAccount(input: $input) {
      bankAccount {
        id
        bank
      }
    }
  }
`

export default {
  CREATE_BANK_ACCOUNT
}
